import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import {
  UitkCardAspectRatios,
  UitkCardTags
} from "./types.js";
export function UitkCard({
  backgroundTheme,
  border,
  children,
  className,
  overflow,
  padded,
  padding,
  placeholder,
  selected,
  tag,
  style,
  ...attributes
}) {
  let actionArea;
  let featuredHeader;
  let link;
  let placeholderChild;
  const newChildren = [];
  const Tag = tag && UitkCardTags.get(tag) || UitkCardTags.get("div");
  const childrenArray = React.Children.toArray(children);
  React.Children.forEach(children, (child) => {
    if (!child) {
      return;
    }
    switch (child.type.displayName) {
      case "UitkCardActionArea":
        actionArea = child;
        break;
      case "UitkCardFeaturedHeader":
        featuredHeader = child;
        break;
      case "UitkCardLink":
        link = child;
        break;
      case "UitkCardPlaceholder":
        placeholderChild = child;
        break;
      default:
        newChildren.push(child);
    }
  });
  const paddingSize = padding ?? (padded ? "medium" : "none");
  const baseClass = "uitk-card";
  const ratioClass = placeholder && UitkCardAspectRatios.get(placeholder.aspectRatio);
  const backgroundClass = backgroundTheme ?? "primary";
  const cssClassNames = classNames(
    baseClass,
    actionArea && `${baseClass}-has-action-area`,
    border && `${baseClass}-has-border`,
    placeholder && `${baseClass}-has-placeholder-border`,
    placeholder && `${baseClass}-${ratioClass}`,
    featuredHeader && `${baseClass}-has-featured-header`,
    link && `${baseClass}-has-link`,
    overflow && `${baseClass}-has-overflow`,
    padding !== "none" && `${baseClass}-padding-${paddingSize}`,
    selected && `${baseClass}-selected`,
    !children && `${baseClass}-empty`,
    className,
    `${baseClass}-has-${backgroundClass}-theme`
  );
  if (placeholderChild) {
    return React.cloneElement(placeholderChild, {
      className: cssClassNames,
      style
    });
  }
  if (childrenArray.length > 1) {
    return /* @__PURE__ */ React.createElement(Tag, { className: cssClassNames, ...attributes, style }, featuredHeader, newChildren, actionArea, link);
  }
  if (childrenArray.length === 1) {
    const firstChild = childrenArray[0];
    return React.cloneElement(firstChild, {
      className: firstChild.props.className ? `${cssClassNames} ${firstChild.props.className}` : `${cssClassNames}`,
      style
    });
  }
  return /* @__PURE__ */ React.createElement(Tag, { className: cssClassNames, style, ...attributes });
}
;
UitkCard.displayName = "UitkCard";
export const UitkCardAloha = UitkCard;
